import { keys, pipe } from 'lodash/fp';
import compactObject from './compactObject';
export var keysIfTrue = pipe([compactObject, keys]);
export default keysIfTrue;